module.exports = __webpack_public_path__ + "static/img/3-2.efa4956.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-2.jpg
// module id = nFlY
// module chunks = 1